import { TAO_KOE, EN_KO } from './../libs';

const Social = {};
Social.init = function() {
	document.addEventListener( 'click', ( evt ) => {
		const targetEl = evt.target;
		if ( ! targetEl.closest( '.tao-mdl-social a' ) ) {
			return;
		}

		const linkEl = targetEl.closest( '.tao-mdl-social a' );
		const action = linkEl.dataset.taoAction;
		let href = linkEl.getAttribute( 'data-href' ) || linkEl.getAttribute( 'href' );

		switch ( action ) {
			case 'share':
				evt.preventDefault();
				TAO_KOE.sharer( href );
				return false;

			case 'email':
				const taoEmailShareForm = window.tao_emailshare_form || '';

				evt.preventDefault();
				linkEl.setAttribute( 'data-href', href );
				if ( href !== taoEmailShareForm + '?data=' + encodeURIComponent( href ) ) {
					href = taoEmailShareForm + '?data=' + encodeURIComponent( href );
					linkEl.setAttribute( 'href', href );
				}

				TAO_KOE.lightboxSharer( href );
				return false;

			case 'print':
				evt.preventDefault();
				window.print();
				return false;
		}

		return true;
	} );
};

TAO_KOE.sharer = function( href ) {
	const share = window.open( href,
		'Share',
		'height=640, width=640, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no',
	);
	share.focus();
	return false;
};

TAO_KOE.lightboxSharer = function( href ) {
	return new Promise( ( resolve ) => {
		const popupEl = document.getElementById( 'popup_tao_emailshare' );
		if ( ! popupEl ) {
			return fetch( href )
				.then( ( resp ) => resp.text() )
				.then( ( html ) => {
					const fragmentEl = document.createRange().createContextualFragment( html );
					document.body.append( fragmentEl );
					resolve();
				} );
		}
		resolve();
	} ).then( () => {
		EN_KO.functions.open_popup( '#popup_tao_emailshare' );
	} );
};

// Init.
TAO_KOE.ready( 'social.js', Social.init );

// Expose.
TAO_KOE.Social = Social;
export default Social;
